"use client";

import { useEffect } from "react";

import type { InstantAssistantContextCard } from "@/types/assistant";

import { useInstantAssistantStore } from "../useInstantAssistantStore";

export function useAssistantContextSource(
  sourceId: string,
  cards: InstantAssistantContextCard[],
): void {
  const setAutoContextSource = useInstantAssistantStore((state) => state.actions.setAutoContextSource);
  const clearAutoContextSource = useInstantAssistantStore((state) => state.actions.clearAutoContextSource);

  useEffect(() => {
    setAutoContextSource(sourceId, cards);

    return () => {
      clearAutoContextSource(sourceId);
    };
  }, [cards, sourceId, setAutoContextSource, clearAutoContextSource]);
}
